import { Link } from "react-router-dom"
import { Button } from "@/components/ui/Button"
import { useTranslation } from "react-i18next"

export function HeroSection() {
    const { t } = useTranslation('landing')

    return (
        <section className="relative overflow-hidden py-20 md:py-32">
            {/* Animated gradient mesh background with orbs */}
            <div className="absolute inset-0 -z-10">
                {/* Base gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 via-purple-500/10 to-pink-500/20 dark:from-emerald-500/10 dark:via-purple-500/5 dark:to-pink-500/10" />

                {/* Emerald Orb - top right */}
                <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-br from-emerald-500/40 to-purple-500/30 rounded-full blur-[120px] animate-pulse-slow" />

                {/* Purple Orb - bottom left */}
                <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-purple-500/40 to-pink-500/30 rounded-full blur-[100px] animate-pulse-slow" />

                {/* Pink Orb - top left */}
                <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-gradient-to-r from-pink-500/30 to-emerald-500/20 rounded-full blur-[80px] animate-pulse-slow" />

                {/* Grid pattern overlay */}
                <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,black_40%,transparent_100%)]" />
            </div>

            {/* Floating decorative shapes */}
            <div className="absolute top-32 left-[10%] w-4 h-4 bg-emerald-500/60 rounded-full animate-float" />
            <div className="absolute top-48 right-[15%] w-6 h-6 bg-purple-500/60 rounded-full animate-float" />
            <div className="absolute bottom-40 left-[20%] w-3 h-3 bg-pink-500/50 rounded-full animate-float" />
            <div className="absolute top-1/3 right-[25%] w-5 h-5 bg-purple-500/50 rounded-full animate-float" />
            <div className="absolute bottom-1/3 left-[15%] w-8 h-8 bg-gradient-to-r from-emerald-500/40 to-pink-500/40 rounded-full animate-float" />

            <div className="container mx-auto px-4 text-center relative z-10">
                {/* Gradient text headline */}
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 dark:from-purple-400 dark:to-pink-400">
                    {t('hero.title')}
                </h1>

                <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto mb-10 animate-fade-in-up">
                    {t('hero.subtitle')}
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up">
                    <Link to="/register">
                        <Button
                            size="lg"
                            className="bg-gradient-to-r from-emerald-500 to-purple-500 hover:from-emerald-600 hover:to-purple-600 hover:scale-105 transition-all duration-300 shadow-lg shadow-emerald-500/25 dark:shadow-emerald-500/20 hover:shadow-xl hover:shadow-emerald-500/30 text-white"
                        >
                            {t('hero.cta.createPage')}
                        </Button>
                    </Link>
                    <Link to="/login">
                        <Button
                            size="lg"
                            variant="outline"
                            className="border-2 border-purple-500/50 hover:border-purple-500 hover:scale-105 transition-all duration-300 text-purple-600 dark:text-purple-400"
                        >
                            {t('hero.cta.signIn')}
                        </Button>
                    </Link>
                </div>
            </div>
        </section>
    )
}
